import React from 'react';

const Page12ThankYou = ({ 
  handlePrevious,
  handleSubmit,
  isSubmitting 
}) => {
  return (
    <>
      <div className="thank-you-container">
        <h2 className="thank-you-heading">Thank you for your feedback!</h2>
        <p className="thank-you-text">We appreciate your time and input. Please click the Submit button to complete the survey.</p>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button submit-button" 
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </>
  );
};

export default Page12ThankYou;
